import { ChakraProvider, ColorModeScript, extendTheme } from "@chakra-ui/react";
import * as React from "react";
import ReactDOM from "react-dom";
import { App } from "./App";
import { AuthProvider } from "./providers/AuthProvider";
import { BrowserRouter as Router } from "react-router-dom";

import reportWebVitals from "./reportWebVitals";
import * as serviceWorker from "./serviceWorker";
import { ReactQueryDevtools } from "react-query-devtools";
import { QueryCache, ReactQueryCacheProvider } from "react-query";
import ImageModalProvider from "providers/ImageModalProvider";

const theme = extendTheme({
  colors: {
    primary: { 500: "#2cb9a9", 100: "#2cb9a9", 900: "#309186" },
    accent: { 500: "#66d3fb" },
    disabled: { 500: "#505b68" },
    highlight: { 500: "#3e4a59" },
    background: { 500: "#ffffff" },
    disabledBg: { 500: "#fbfbfb" },
    starYellow: { 500: "#fddb00" },
    settingText: { 500: "#7C7D8F" },
    appointmentYellow: { 500: "#e19600" },
    error: { 500: "#fa6969" },
    unselectedText: { 500: "#707070" },
    loginText: { 500: "#aba0ae" },
    labelText: { 500: "#868e96" },
    richText: { 500: "#9b9b9b" },
    black: { 500: "#424360" },
    containerBg: { 500: "#f7f6f3" },
    border: { 500: "#EBECF2" },
    faded: { 500: "#F5F5F5" },
    modalHeader: { 500: "#424360" },
    gradient2: { 500: "#1FE8D4" },
    gradient1: { 500: "#1D97FC" },
    borderHighlight: { 100: "#EFFBFF", 500: "#B1E5F7" },
  },
  radii: {
    md: 3,
  },
  styles: {
    global: {
      "html, body, #root": {
        height: "100%",
      },
      html: {
        fontFamily: "montserrat",
        scrollBehavior: "smooth",
      },
    },
  },
  components: {
    Button: {
      defaultProps: {
        colorScheme: "primary",
      },
      baseStyle: {
        borderRadius: "3px",
        _focus: {
          boxShadow: "none",
        },
      },
    },
    Badge: {
      baseStyle: {
        px: 2,
        textTransform: "capitalize",
        borderRadius: "99999px",
        fontWeight: 400,
      },
    },
    Table: {
      baseStyle: {
        td: {
          color: "gray.500",
        },
      },
    },
  },
});

const queryCache = new QueryCache({
  defaultConfig: {
    queries: {
      staleTime: 1000 * 60 * 5,
      retry: false,
    },
  },
});

ReactDOM.render(
  <React.StrictMode>
    <ColorModeScript />
    <ChakraProvider theme={theme}>
      <ReactQueryCacheProvider queryCache={queryCache}>
        <Router>
          <AuthProvider>
            <ImageModalProvider>
              <App />
            </ImageModalProvider>
          </AuthProvider>
        </Router>
        <ReactQueryDevtools initialIsOpen />
      </ReactQueryCacheProvider>
    </ChakraProvider>
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorker.unregister();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
reportWebVitals();
